var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9907 10.1637C19.9907 9.41794 19.9192 8.87105 19.7763 8.29102H10.5205V11.6883H15.9525C15.8453 12.5335 15.2556 13.793 13.9334 14.6548L13.9155 14.7708L16.8459 16.8755L17.0424 16.8921C18.9186 15.3011 19.9907 12.9479 19.9907 10.1637Z",
    fill: "#4877BB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5197 19.1121C13.1821 19.1121 15.4157 18.3 17.0417 16.8914L13.9326 14.6541C13.0928 15.1844 11.9849 15.5656 10.5197 15.5656C7.91096 15.5656 5.69529 13.9746 4.90908 11.7705L4.80187 11.7871L1.76425 13.9746L1.72852 14.0741C3.33667 17.0571 6.67805 19.1121 10.5197 19.1121Z",
    fill: "#21A849"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9096 11.7708C4.69518 11.2073 4.58797 10.5941 4.58797 9.96438C4.58797 9.33463 4.71305 8.72145 4.9096 8.15799V8.04198L1.83625 5.82129L1.72903 5.871C1.06791 7.11393 0.674805 8.50601 0.674805 9.98095C0.674805 11.4559 1.05004 12.848 1.72903 14.0909L4.9096 11.7708Z",
    fill: "#FBBA10"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5205 4.36293C12.3788 4.36293 13.6117 5.10868 14.3265 5.72185L17.1139 3.20286C15.3986 1.72792 13.1829 0.833008 10.5205 0.833008C6.66095 0.833008 3.33744 2.88798 1.71143 5.87101L4.89199 8.17457C5.71393 5.95387 7.91173 4.36293 10.5205 4.36293Z",
    fill: "#E73830"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.d5f589b3795f243c933889b0a26349a3.svg";
export { ForwardRef as ReactComponent };